export default {
  blog_page: {
    title: "Blog"
  },
  show: {
    tags: "Tags",
    suggested_articles: "See other articles!"
  }
}